var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail"},[_c('course',{key:_vm.id,ref:"course",attrs:{"id":_vm.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }